import { useSyncExternalStore } from "react"

type WindowSize = {
  width: number
  height: number
}

const getWindowSize = (): WindowSize => {
  // oxlint-disable-next-line typescript/no-unnecessary-condition
  if (globalThis.window === undefined) {
    return {
      width: 0,
      height: 0,
    }
  }

  return {
    width: globalThis.window.innerWidth,
    height: globalThis.window.innerHeight,
  }
}

let windowSizeSnapshot: WindowSize = getWindowSize()
const getSnapshot = () => windowSizeSnapshot

const subscribe = (onStoreChange: () => void) => {
  const handleResize = () => {
    const nextSnapshot = getWindowSize()
    if (
      nextSnapshot.width !== windowSizeSnapshot.width ||
      nextSnapshot.height !== windowSizeSnapshot.height
    ) {
      windowSizeSnapshot = nextSnapshot
      onStoreChange()
    }
  }

  globalThis.window.addEventListener("resize", handleResize)
  // Re-sync on subscribe: the window may have changed size before any consumer
  // mounted (e.g. a resize while no consumer was subscribed), and `getSnapshot`
  // returns the cached snapshot, not a fresh read.
  handleResize()
  return () => {
    globalThis.window.removeEventListener("resize", handleResize)
  }
}

const useWindowSize = (): WindowSize =>
  useSyncExternalStore(subscribe, getSnapshot)

export { useWindowSize }
